<div class="bg-deep-blue mb-3">
  <div class="d-flex justify-content-between align-items-center cabecalho">
    <img src="{{logo}}" class="cabecalho-logo">
    <h2 class="f-lg-24 f-sm-18 f-sm-12 text-center">{{titulo}}</h2>
    <div class="d-flex justify-content-between align-items-center cabecalho">
      <app-header-placa [cabecalho]="cabecalho" class="responsive-placa d-none d-md-block"></app-header-placa>
      <app-header-qrcode [qrcodeUrl]="qrcodeUrl"></app-header-qrcode>
    </div>
  </div>
</div>
